import React from "react";

import {
  AudioTrack as IAudioTrack,
  LocalTrackPublication,
  Participant,
  RemoteTrackPublication,
  Track,
} from "twilio-video";
import VideoTrack from "../VideoTrack/VideoTrack";
import AudioTrack from "../AudioTrack/AudioTrack";
import { IVideoTrack } from "../../constants/types";
import useTrack from "../../hooks/useTrack/useTrack";

interface IPublicationProps {
  publication: LocalTrackPublication | RemoteTrackPublication;
  participant: Participant;
  isLocalParticipant?: boolean;
  videoOnly?: boolean;
  videoPriority?: Track.Priority | null;
}

const Publication: React.FC<IPublicationProps> = ({
  publication,
  isLocalParticipant,
  videoOnly,
  videoPriority,
}) => {
  const track = useTrack(publication);

  if (!track) return null;

  switch (track.kind) {
    case "video":
      return (
        <VideoTrack
          track={track as IVideoTrack}
          priority={videoPriority}
          isLocal={!track.name.includes("screen") && isLocalParticipant}
        />
      );
    case "audio":
      return videoOnly ? null : <AudioTrack track={track as IAudioTrack} />;
    default:
      return null;
  }
};

export default Publication;
